import {
  ADD_COMMENT,
  CLEAR_COMMENTS,
  DELETE_COMMENT,
  SET_REPLIES,
  SET_SPARK_COMMENTS,
  UPDATE_COMMENT,
} from '../actions';

const initialState = {
  sparkId: null,
  comments: [],
};

export function sparksReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SPARK_COMMENTS:
      return {
        sparkId: action.payload.sparkId,
        comments: action.payload.comments,
      };

    case CLEAR_COMMENTS:
      return {
        sparkId: null,
        comments: [],
      };

    case ADD_COMMENT:
      return {
        ...state,
        comments: [action.payload, ...state.comments],
      };

    case UPDATE_COMMENT:
      const updateRecursive = (list) =>
        list.map((item) => {
          if (item.id === action.payload.id) return action.payload;
          if (item.replies) {
            return { ...item, replies: updateRecursive(item.replies) };
          }
          return item;
        });
      return {
        ...state,
        comments: updateRecursive(state.comments),
      };

    case DELETE_COMMENT:
      const deleteRecursive = (list) =>
        list
          .filter((item) => item.id !== action.payload)
          .map((item) => ({
            ...item,
            replies: item.replies ? deleteRecursive(item.replies) : [],
          }));
      return {
        ...state,
        comments: deleteRecursive(state.comments),
      };

    case SET_REPLIES:
      const setRepliesRecursive = (list) =>
        list.map((item) => {
          if (item.id === action.payload.parentId) {
            return { ...item, replies: action.payload.replies };
          } else if (item.replies) {
            return { ...item, replies: setRepliesRecursive(item.replies) };
          }
          return item;
        });
      return {
        ...state,
        comments: setRepliesRecursive(state.comments),
      };

    default:
      return state;
  }
}
